import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/cabinet')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const ifPayments = (to, from, next) => {
  if (store.getters.ifPayments) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', alias: '/kitchen', name: 'Панель', component: () => import('../components/panel')},
    {path: '/cabinet', name: 'Монитор', component: () => import('../components/dashboard'), beforeEnter: ifAuthenticated},
    {path: '/widgets', name: 'Виджеты', component: () => import('../components/widgets'), beforeEnter: ifAuthenticated},
    {path: '/widget/:id', name: 'widget', component: () => import('../components/widget'), beforeEnter: ifAuthenticated},
    {path: '/clients', name: 'Клиенты', component: () => import('../components/clients'), beforeEnter: ifAuthenticated},
    {path: '/client/:id', name: 'client', component: () => import('../components/client'), beforeEnter: ifAuthenticated},
    {path: '/bitrix/:id', name: 'bitrix', component: () => import('../components/clientBitrix')},
    {path: '/monitoring', name: 'WA:Мониторинг', component: () => import('../components/monitoringv2'), beforeEnter: ifAuthenticated},
    {path: '/qr/:id/:instance', name: 'qr', component: () => import('../components/qr')},
    {path: '/leads', name: 'leads', component: () => import('../components/leads'), beforeEnter: ifPayments},
    {path: '/lead/:id', name: 'lead', component: () => import('../components/sidebarPays'), beforeEnter: ifPayments},
    {path: '/app-lead/:from/:subdomain/:user/:id/:page', name: 'app-lead', component: () => import('../components/app/index')},
    {path: '/login', name: 'Авторизация', component: () => import('../components/auth'), beforeEnter: ifNotAuthenticated},
    {path: '/whatsapp/:id', name: 'wclient', component: () => import('../components/whatsapp'), beforeEnter: ifAuthenticated},
    {path: '/wa-set-amo/asdasdfasq212412412/qwdqwe3421er2c/12/341231242fd12f1r12341/2f12/:id', name: 'wclient2', component: () => import('../components/whatsapp2')},
    {path: '/whatsapp', name: 'WhatsApp', component: () => import('../components/whatsapps'), beforeEnter: ifAuthenticated},
    {path: '/interface/whatsapp/:id/blacklist', name: 'DeathNote', component: () => import('../components/bl')},
    {path: '/interface/calendar/:id/map', name: 'calendarmap', component: () => import('../components/map')},
    {path: '/interface/whatsapp/:id/instructions', name: 'Instructions', component: () => import('../components/instructions')},
    {path: '/interface/calculator/:id', name: 'Calculator', component: () => import('../components/calculator')},
    {path: '/new/:account/:instance?', name: 'new', component: () => import('../components/new')},
    {path: '*', name: '404', component: () => import('../components/404')}
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js